import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import en from '../../public/assets/lang/en.json'
import da from '../../public/assets/lang/da.json'

Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: { en, da }
})

export function setI18nLanguage(lang) {
    i18n.locale = lang
    axios.defaults.headers.common['Accept-Language'] = lang
    document.querySelector('html').setAttribute('lang', lang)
    return lang
}
